import React, { useContext, useCallback } from 'react';
import { FiPower } from 'react-icons/fi';

import { 
  Container,
  ToggleText,
  ToggleCircle,
  ToggleContainer,
} from './styles';

import { LeftSideBarContext } from '../index';
import { useAuth } from '../../../context/AuthContext';
import { useTheme } from '../../../context/ThemeContext'; // Importando seu context de tema
import { useIndexedDB } from '../../../context/IndexedDBContext';

import BurgerButton from '../BurgerButton';

const TopSection: React.FC = () => {
  const { signOut } = useAuth();  
  const { theme, toggleTheme, chaveStorageTheme } = useTheme();
  const { gravarIndexedDB } = useIndexedDB();
  
  const { setIsShowSideBar } = useContext(LeftSideBarContext);

  const trocarTema = useCallback(() => {
    toggleTheme();
    gravarIndexedDB(chaveStorageTheme, (theme === 'dark' ? 'light' : 'dark'));
  }, [toggleTheme, chaveStorageTheme, gravarIndexedDB, theme]);

  return (
    <Container>
      <BurgerButton onClick={() => setIsShowSideBar(true)} />

      <p></p>

      {/* <button onClick={toggleTheme}>
        Mudar para {theme === 'dark' ? 'Light' : 'Dark'} Theme
      </button> */}
      <ToggleContainer onClick={trocarTema}>
        <ToggleCircle />
        <ToggleText>{theme === 'dark' ? 'Dark' : 'Light'}</ToggleText>
      </ToggleContainer>
      {/* <FiSettings /> */}
      <button type='button' onClick={signOut}>
        <FiPower />
      </button>
    </Container>
  );
}

export default TopSection;
